import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Visits.css';

const Visits = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const statsRef = useRef(null);
  const regionsRef = useRef(null);
  const onlineRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const stats = statsRef.current;
    const regions = regionsRef.current;
    const online = onlineRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => title.classList.add('visible'), 200);
          setTimeout(() => description.classList.add('visible'), 400);
          setTimeout(() => stats.classList.add('visible'), 600);
          setTimeout(() => regions.classList.add('visible'), 800);
          setTimeout(() => online.classList.add('visible'), 1000);
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="visits" ref={sectionRef}>
      <div className="visits-background">
        <div className="visits-shape visits-shape-1"></div>
        <div className="visits-shape visits-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="visits-content">
          <h2 className="visits-title" ref={titleRef}>
            {t('visitsTitle')}
          </h2>
          
          <p className="visits-description" ref={descriptionRef}>
            {t('visitsDescription')}
          </p>
          
          <div className="visits-stats" ref={statsRef}>
            <div className="visits-regions" ref={regionsRef}>
              <div className="visits-icon">📍</div>
              <div className="visits-text">{t('visitsRegions')}</div>
            </div>
            
            <div className="visits-online" ref={onlineRef}>
              <div className="visits-icon">💻</div>
              <div className="visits-text">{t('visitsOnline')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visits;
